/**
 * *****************
 * BACK TO TOP JS
 * *****************
 */

/**
 * Variables
 *
 * @type {Element}
 */
var buttonScrollTop = document.querySelector('[data-js="button-scroll-top"]');

/**
 * Function trackScroll
 *
 * Show or hide button
 */
function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = document.documentElement.clientHeight;

    if (scrolled > coords) {
        buttonScrollTop.style.display = 'block';
    }
    if (scrolled < coords) {
        buttonScrollTop.style.display = 'none';
    }
}

/**
 * Function backToTop
 *
 * Check if the scrolling is greater of zero and scroll
 */
function backToTop() {
    if (window.pageYOffset > 0) {
        window.scrollBy(0, -80);
        setTimeout(backToTop, 0);
    }
}

/**
 * Init
 */
window.addEventListener('scroll', trackScroll);
buttonScrollTop.addEventListener('click', backToTop);